/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Signed_TitleInputs */

const tr_landing_telegram_mock_signed_title = /** @type {(inputs: Landing_Telegram_Mock_Signed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-FATURA İMZALANDI · GİB ONAYLI`)
};

const en_landing_telegram_mock_signed_title = /** @type {(inputs: Landing_Telegram_Mock_Signed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-INVOICE SIGNED · GİB APPROVED`)
};

const de_landing_telegram_mock_signed_title = /** @type {(inputs: Landing_Telegram_Mock_Signed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-FATURA SIGNIERT · GİB-BESTÄTIGT`)
};

const ru_landing_telegram_mock_signed_title = /** @type {(inputs: Landing_Telegram_Mock_Signed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-FATURA ПОДПИСАНА · ОДОБРЕНО GİB`)
};

/**
* | output |
* | --- |
* | "E-INVOICE SIGNED · GİB APPROVED" |
*
* @param {Landing_Telegram_Mock_Signed_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_signed_title = /** @type {((inputs?: Landing_Telegram_Mock_Signed_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Signed_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_signed_title(inputs)
	if (locale === "de") return de_landing_telegram_mock_signed_title(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_signed_title(inputs)
	return tr_landing_telegram_mock_signed_title(inputs)
});